import React from "react";
import { Container, Row, Col, Form, Button } from "react-bootstrap";
import { FiMail } from "react-icons/fi";
import "../../assets/css/ForgotPassword.css";

const ForgotPassword = () => {
  return (
    <div className="fp-wrapper">
      <Container fluid className="p-0">
        <Row className="g-0">
          {/* LEFT SIDE */}
          <Col lg={5} className="fp-left d-none d-lg-block">
            <div className="fp-left-inner">
              {/* Background shapes */}
              <img src="/assets/img/bg/bg-01.png" className="shape-1" alt="" />
              <img src="/assets/img/bg/bg-02.png" className="shape-2" alt="" />
              <img src="/assets/img/bg/bg-03.png" className="shape-3" alt="" />

              <div className="fp-card">
                <h1>
                  Empowering people <br />
                  through seamless HR <br />
                  management.
                </h1>

                <img
                  src="/assets/img/bg/authentication-bg-01.png"
                  className="fp-img"
                  alt=""
                />

                <p>
                  Efficiently manage your workforce, streamline
                  <br /> operations effortlessly.
                </p>
              </div>
            </div>
          </Col>

          {/* RIGHT SIDE */}
          <Col lg={7} className="fp-right">
            <div className="fp-right-inner">
              {/* LOGO */}
              <div className="fp-logo">
                <img src="/assets/img/logo-1.svg" alt="" />
              </div>

              {/* FORM */}
              <div className="fp-form">
                <h2>Forgot Password?</h2>
                <p>
                  If you forgot your password, well, then we'll email you
                  instructions to reset your password.
                </p>

                <Form>
                  <Form.Group>
                    <Form.Label>Email Address</Form.Label>

                    <div className="fp-input">
                      <Form.Control type="email" />
                      <FiMail />
                    </div>
                  </Form.Group>

                  <Button className="fp-btn">Submit</Button>
                </Form>

                <div className="fp-return">
                  Return to <span>Sign In</span>
                </div>
              </div>

              {/* FOOTER */}
              <div className="fp-footer">Copyright © 2026 - Spectronx</div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default ForgotPassword;
